import { useNavigate } from "react-router-dom";
import { useScreenSize, useAppDispatch } from "hooks";
import { Button } from "components/atoms/Button";
import { TextIcon } from "components/atoms/TextIcon";
import { TextOptionPagination } from "../TextOptionPagination";
import { CONTENT_OBJECT_TYPE_ID, MOBILE_WIDTH } from "utils/constants";
import { decodeToken } from "utils/functions/decodeToken";
import { openExternalUrl } from "utils/functions/openExternalUrl";
import "./index.scss";

interface IProps {
  isMobile?: boolean;
  exams?: any;
  textIconStyle?: string;
  theme: "light" | "dark";
  type: any;
}

export const SelfPacedTextOptionBtn = ({
  isMobile,
  exams,
  textIconStyle,
  theme,
  type,
}: IProps) => {
  const matchBtnLabel = (status: any) => {
    switch (status) {
      case "Not Started":
        return "Start Diagnostic Exam";
      case "Inprogress":
        return "Resume";
      case "Complete":
        return "Restart Diagnostic Exam";
      default:
        return "Start Diagnostic Exam";
    }
  };

  const screen = useScreenSize();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const payload = decodeToken();

  const handleClick = (value: any) => {
    // Check if this is a DrillSmartGrouping object
    if (value._isDrillSmartGrouping === true) {
      // Check if DrillSmartGrouping is locked
      if (value.IsLocked === true) {
        if (screen.width <= MOBILE_WIDTH) {
          navigate("/self-paced/unlock");
        } else {
          // On desktop, locked content should navigate to unlock
          navigate("/self-paced/unlock");
        }
        return;
      }
      // For DrillSmart items, open the LaunchUrl (which is the DrillSmart launch URL)
      if (value.LaunchUrl) {
        window.open(value.LaunchUrl, "__blank");
      }
      return;
    }
    
    if (
      (value.Status === "Lock" || value.IsLocked === true) &&
      screen.width <= MOBILE_WIDTH
    ) {
      navigate("/self-paced/unlock");
    } else if (
      (value.ContentObjectTypeId === CONTENT_OBJECT_TYPE_ID.OfflineDrill ||
        value.ContentObjectTypeId === CONTENT_OBJECT_TYPE_ID.OfflineReading) &&
      screen.width <= MOBILE_WIDTH
    ) {
      navigate("/self-paced/drill", {
        state: {
          ...value,
          ContentObjectGuid: value.Guid,
          ContentObjectType: Object.keys(CONTENT_OBJECT_TYPE_ID).find(
            (key: string) =>
              CONTENT_OBJECT_TYPE_ID[key] === value.ContentObjectTypeId
          ),
        },
      });
    } else {
      const testtype = payload?.testtype;
      const contentType = Object.keys(CONTENT_OBJECT_TYPE_ID).find(
        (key: string) =>
          CONTENT_OBJECT_TYPE_ID[key] === value.ContentObjectTypeId
      );
      openExternalUrl({
        url: value.LaunchUrl,
        contentObjectType: contentType,
        testType: testtype,
        dispatch,
      });
    }
  };

  return (
    <>
      {exams && Array.isArray(exams) && exams.length > 5 ? (
        <TextOptionPagination
          exams={exams}
          theme={theme}
          textIconStyle={textIconStyle}
          handleClick={handleClick}
        />
      ) : (
        exams &&
        Array.isArray(exams) &&
        exams.length > 0 &&
        exams.map((value: any, index: number) => {
          const isDrillSmartGrouping = value._isDrillSmartGrouping === true;
          
          return (
            <div className="text-option-btn-wrapper" key={index}>
              <div className="text-option-section">
                <TextIcon
                  label={isDrillSmartGrouping ? value.GroupName : value.Name}
                  icon={true}
                  isReverse={true}
                  iconType={
                    isDrillSmartGrouping
                      ? (value.IsLocked === true ? "lock" : "empty-circle")
                      : value.Status === "Lock" || value.IsLocked === true
                        ? "lock"
                        : value.Status === "Not Started"
                          ? "empty-circle"
                          : value.Status === "Completed" ||
                              value.Status === "Complete"
                            ? "select"
                            : "yellow-timer"
                  }
                  isTabStyle={true}
                  styles={textIconStyle}
                  theme={theme}
                  onClick={() => handleClick(value)}
                />
              </div>

              {isMobile ? null : (
                <div className="self-paced-btn-section">
                  {isDrillSmartGrouping && value.IsLocked === true ? (
                    <Button
                      type="score"
                      label="Unlock All Content"
                      icon={false}
                      styles="custom-text-option-btn"
                      onClick={() => navigate("/self-paced/unlock")}
                    />
                  ) : (
                    <>
                      {!isDrillSmartGrouping && (value.Status === "Completed" || value.Status === "Complete") ? (
                        <Button
                          type="online"
                          label="View Result"
                          icon={false}
                          styles="custom-text-option-btn"
                          onClick={() => window.open(value.LaunchUrl, "___blank")}
                        />
                      ) : null}
                      <Button
                        type="score"
                        label={isDrillSmartGrouping ? "Start DrillSmart" : matchBtnLabel(value.Status)}
                        icon={false}
                        styles="custom-text-option-btn"
                        onClick={() => handleClick(value)}
                      />
                    </>
                  )}
                </div>
              )}
            </div>
          );
        })
      )}
    </>
  );
};
